import Vue from 'vue'
import Vuex from 'vuex'
import {alert} from './modules/alerts.js';
import {studio} from './modules/studio.js';
import {client} from './modules/client.js';
import {passCode} from './modules/passCode.js';
import {pagination} from "./modules/pagination";
import {modal} from "./modules/modal";
import {preloader} from "./modules/preloader";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
      client,
      alert,
      studio,
      passCode,
      pagination,
      modal,
      preloader
  }
})
